import React from 'react';
import { LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import styles from './List.module.css'
import { FederalReviewListItem } from './ListItem';

class PeerReviewFederalList extends React.Component {

    render() {
        return (
            <div>
                {this.props.loading &&
                    <div className={styles.loading_container}>
                        <LoadingIcon size="small" />
                    </div>
                }
                <ScrollDiv divId={'MC_FEDERAL'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .map(key => {
                            const message = this.props.messages[key];
                            return <FederalReviewListItem
                                key={message.nono}
                                id={message.nono}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let messages = Object.keys(state.entities.federalReviewMsgs)
    .sort((a, b) => new Date(state.entities.federalReviewMsgs[b].lastSeen) - new Date(state.entities.federalReviewMsgs[a].lastSeen))
    .map(x => state.entities.federalReviewMsgs[x]);

    return {
        messages,
        loading: state.ui.federalReviewMsgs.loading
    };
}

const connectedPeerReviewFederalList = connect(mapStateToProps)(PeerReviewFederalList);
export { connectedPeerReviewFederalList as PeerReviewFederalList };